import { render, staticRenderFns } from "./AddArtist.vue?vue&type=template&id=b16391ea&scoped=true&"
import script from "./AddArtist.vue?vue&type=script&lang=js&"
export * from "./AddArtist.vue?vue&type=script&lang=js&"
import style0 from "./AddArtist.vue?vue&type=style&index=0&id=b16391ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16391ea",
  null
  
)

export default component.exports